import api from '../token';

export const DeleteFornecedor = async (dados) => {
  try {
    const response = await api.post('/deleteFornecedor', dados);
    return response.data;
  } catch (error) {
     
    return { success: false, message: error.message };
  }
};


